import createPersistedState from 'vuex-persistedstate'
import * as types from '../mutation-types/editor-layers-expand-components'

const namespaced = true
export const namespace = 'EditorLayersExpandComponents'

// state
const state = {
    expandComponentLayer: {},
}

const expand = (s, contentId, componentCid) => {
    const expandComponentLayer = s.expandComponentLayer

    if (!expandComponentLayer[contentId]) {
        expandComponentLayer[contentId] = []
    }

    if (!expandComponentLayer[contentId].includes(componentCid)) {
        expandComponentLayer[contentId].push(componentCid)
        s.expandComponentLayer = Object.assign({}, expandComponentLayer)
    }
}

const unexpand = (s, contentId, componentCid) => {
    const expandComponentLayer = s.expandComponentLayer

    const idx = expandComponentLayer[contentId]?.indexOf(componentCid)
    if (idx !== undefined && idx >= 0) {
        expandComponentLayer[contentId].splice(idx, 1)
        s.expandComponentLayer = Object.assign({}, expandComponentLayer)
    }
}

const checkExpand = (s, contentId, componentCid) => {
    return s.expandComponentLayer[contentId]?.includes(componentCid) || false
}

// mutations
const mutations = {
    [types.EXPAND_COMPONENT_LAYER](s, {contentId, componentCid}) {
        expand(s, contentId, componentCid)
    },
    [types.UNEXPAND_COMPONENT_LAYER](s, {contentId, componentCid}) {
        unexpand(s, contentId, componentCid)
    },
    [types.TOGGLE_EXPAND_COMPONENT_LAYER](s, {contentId, componentCid}) {
        if (checkExpand(s, contentId, componentCid)) {
            unexpand(s, contentId, componentCid)
        } else {
            expand(s, contentId, componentCid)
        }
    },
}

const actions = {
    expandComponentLayer({commit}, payload) {
        commit(types.EXPAND_COMPONENT_LAYER, payload)
    },
    unexpandComponentLayer({commit}, payload) {
        commit(types.UNEXPAND_COMPONENT_LAYER, payload)
    },
    toggleExpandComponentLayer({commit}, payload) {
        commit(types.TOGGLE_EXPAND_COMPONENT_LAYER, payload)
    },
}

// getters
const getters = {
    getExpandComponentLayer: s => (contentId, componentCid) => {
        return checkExpand(s, contentId, componentCid)
    },
}

// plugins
const plugins = [
    createPersistedState({
        key: 'editor-layers-expand-components',
    })
]

export default {namespaced, namespace, state, mutations, actions, getters, plugins}
